/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureSnapshotCreateRequest {
    getFixupPrototypeFunction() { return TagPostureSnapshotCreateRequest.fixupPrototype; }

    static newInstance(model: Partial<TagPostureSnapshotCreateRequest>): TagPostureSnapshotCreateRequest {
        let obj = Object.assign(new TagPostureSnapshotCreateRequest(), model);
        TagPostureSnapshotCreateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureSnapshotCreateRequest>): TagPostureSnapshotCreateRequest {
        if (!model) return null;
        return TagPostureSnapshotCreateRequest.newInstance(<TagPostureSnapshotCreateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureSnapshotCreateRequest) {
        if (!obj) return;

        models.TagPostureSnapshotCreateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureSnapshotCreateRequest): boolean {
        Object.setPrototypeOf(obj, TagPostureSnapshotCreateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of cloud account ids to include in the snapshot
     */
    cloud_account_ids: Array<string>;

}
